"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var uuid = require("uuid");
/* lifetime of key is until user closes their window / tab */
exports.getSessionKey = function () {
    var sessionKey = "measuredApp.sessionKey";
    var localSessionId = window.sessionStorage
        && window.sessionStorage.getItem(sessionKey);
    var newSessionId = uuid.v4().replace(/-/g, "_");
    if (!localSessionId && window.localStorage) {
        window.sessionStorage.setItem(sessionKey, newSessionId);
    }
    var finalSessionId = localSessionId || newSessionId;
    return finalSessionId;
};
/* lifetime of key is until user clears their local storage (history) */
exports.getBrowserKey = function () {
    var browserKey = "measuredApp.browserKey";
    var localBrowserKey = window.localStorage
        && window.localStorage.getItem(browserKey);
    var newBrowserId = uuid.v4().replace(/-/g, "_");
    if (!localBrowserKey && window.sessionStorage) {
        window.localStorage.setItem(browserKey, newBrowserId);
    }
    var finalBrowserId = localBrowserKey || newBrowserId;
    return finalBrowserId;
};
